import React from 'react';
import {
  MainContent,
  ContentContainer,
  HeaderContainer
} from "../StyledComponents";
import ScrollButton from '../ScrollButton';
import TestimonialCarousel from '../TestimonialCarousel';
import testimonials from '../../data/testimonials.json';
import ContactForm from '../ContactForm';
import FiveReasons from '../FiveReasons';
import TeamIntro from './MeetUs';
import FreeTrialPromo from './FreeTrialPromo';
import { Link as ScrollLink } from 'react-scroll';

function FunnelContactPage() {
  return (
    <MainContent>
      <HeaderContainer>
      </HeaderContainer>
      
      {/* Enhanced first content container with image and button */}
      <ContentContainer className='px-1'>
        <div className="flex flex-col md:flex-row md:items-center md:gap-8 md:ml-4">
          {/* Left content: Title and text */}
          <div className="md:w-1/2">
            <h1 className='text-4xl font-bold text-custom_tertiary md:my-8'>Starte das Programmier-Abenteuer deiner Kinder</h1>
            <p className='my-0 text-lg'>Möchtest du, dass sich dein Kind auf unsere digitale Zukunft vorbereiten kann? Oder, dass es einfach nur sicher mit dem Internet umzugehen lernt und dabei noch spielerisch besser in Mathe, Physik und Informatik wird? In unseren Online-Kursen lernen Kinder Fähigkeiten, die ein Leben lang nützlich sind - von Programmieren, kritischem Denken bis zur Problemlösung und Team Work!</p>
          </div>
          
          {/* Right content: Image and button */}
          <div className="md:w-1/2">
            <div className="flex justify-end">
              <img 
                src="../codekids/codekid1.svg" 
                alt="Kind programmiert" 
                className="w-3/4 my-0"
              />
            </div>
            <div className="flex justify-start">
              <ScrollLink
                to="contact-form-section"
                smooth={true}
                duration={800}
                offset={-100}
                className="mt-4 inline-block px-8 py-3 bg-custom_tertiary text-white text-xl font-semibold no-underline rounded-full shadow-md hover:bg-custom_tertiary/80 hover:text-black transition-colors duration-300 cursor-pointer"
              >
                Jetzt starten!
              </ScrollLink>
            </div>
          </div>
        </div>
      </ContentContainer>
      
      <ScrollButton />
      
      <ContentContainer>
        <FiveReasons/>
      </ContentContainer>

      <ScrollButton />
      
      <ContentContainer>
        <FreeTrialPromo />
      </ContentContainer>
      
      <ScrollButton />
      
      <ContentContainer>
        <TestimonialCarousel testimonials={testimonials} />
      </ContentContainer>
      
      <ScrollButton />
      
      <ContentContainer>
        <TeamIntro />
      </ContentContainer>

      <ScrollButton />
      
      <ContentContainer id="contact-form-section">
        <ContactForm selection="ContactFunnel0"/>
      </ContentContainer>
    </MainContent>
  );
}

export default FunnelContactPage;